import * as React from "react";
import Navbar from "react-bootstrap/Navbar";
import Form from "react-bootstrap/Form";
import FormControl from "react-bootstrap/FormControl";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import { NavbarLinks } from "../Main";

interface NavbarComponentState {
    tableSearch: string;
    fieldSearch: string;
    wholeWords: boolean;
}

interface NavbarComponentProps {
    onSearchChange: (tableSearch: string, fieldSearch: string, wholeWords: boolean) => void;
}

export default class NavbarComponent extends React.Component<NavbarComponentProps, NavbarComponentState> {

    constructor(props: NavbarComponentProps) {
        super(props);

        this.state = {tableSearch: "", fieldSearch: "", wholeWords: false };
    }

    render() {
        return <Navbar bg="light" expand="lg" sticky="top">
            <Navbar.Brand href="#">Změny v databázi</Navbar.Brand>
            <Navbar.Toggle />
            <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="mr-auto">
                    <NavbarLinks />
                </Nav>
                <Form inline className="ml-auto" onSubmit={(e) => e.preventDefault()}>
                    <FormControl type="text" placeholder="Tabulka" className="mr-sm-2 my-2 my-lg-0" size="sm" value={this.state.tableSearch} as="input" onChange={(e) => this.setState({tableSearch: e.currentTarget.value})} />
                    <FormControl type="text" placeholder="Pole" className="mr-sm-2 mb-2 mb-lg-0" size="sm" value={this.state.fieldSearch} as="input" onChange={(e) => this.setState({fieldSearch: e.currentTarget.value})} />
                    <Form.Check label="Celá slova" type="checkbox" className="mr-sm-2 mb-2 mb-lg-0" id="whole-words" checked={this.state.wholeWords} as="input" onChange={() => this.setState({wholeWords: !this.state.wholeWords})} />
                    <Button variant="success" type="submit" size="sm" onClick={() => this.props.onSearchChange(this.state.tableSearch, this.state.fieldSearch, this.state.wholeWords)}>Hledat</Button>
                </Form>
            </Navbar.Collapse>
        </Navbar>
    }

}